import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui-kit/button';
import { Input } from '@/components/ui-kit/input';
import { Label } from '@/components/ui-kit/label';
import { Textarea } from '@/components/ui-kit/textarea';
import { useDocxBuilder } from './context';

export function DocxBuilderPanelDetails() {
  const { title, description, isSavingDetails, saveDetails } = useDocxBuilder();
  const [titleDraft, setTitleDraft] = useState(title);
  const [descDraft, setDescDraft] = useState(description);

  const hasChanges = titleDraft !== title || descDraft !== description;

  const handleSave = () => {
    const next = titleDraft.trim();
    if (!next) return;
    saveDetails(next, descDraft.trim());
  };

  return (
    <div className="rounded-lg  p-2 space-y-4">
      <h2 className="text-sm font-semibold text-[hsl(var(--fg))]">Template details</h2>

      <div className="space-y-1.5">
        <Label htmlFor="builder-title">Title</Label>
        <Input
          id="builder-title"
          value={titleDraft}
          onChange={(e) => setTitleDraft(e.target.value)}
          placeholder="Template name"
        />
      </div>

      <div className="space-y-1.5">
        <Label htmlFor="builder-desc">Description</Label>
        <Textarea
          id="builder-desc"
          value={descDraft}
          onChange={(e) => setDescDraft(e.target.value)}
          placeholder="Briefly describe what this template is for"
          rows={4}
        />
      </div>

      <Button
        onClick={handleSave}
        disabled={!hasChanges || !titleDraft.trim() || isSavingDetails}
        className="w-full"
      >
        {isSavingDetails && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
        Save details
      </Button>
    </div>
  );
}
